// Which attempt a results-grid summary cell shows (v3.92.2).
//
// Re-assessing a student saves a new assessment doc, so one
// student / testType / quarter slot can hold several attempts. Every results
// grid (Letter/Sound Results, Nonsense Word Fluency, PA 4K) shows the latest:
//   - a strictly newer timestamp wins;
//   - an N/A doc (correctCount -1) counts as an attempt;
//   - a tie keeps the first doc seen;
//   - an undated doc seen first is never replaced (new Date(undefined) is
//     Invalid, so the comparison is false) — the grids' long-standing rule.
//
// The grids' summary loop and their hidden double-click edit share this rule,
// so the edit always acts on the attempt the teacher is looking at. Before,
// the edit took `assessments.find()` — the FIRST doc in the slot — and
// clearing an N/A could delete an older scored attempt instead of the N/A.

export const isNewerAttempt = (candidate, current) =>
  !current || !!(candidate.timestamp && new Date(candidate.timestamp) > new Date(current.timestamp));

export const latestAttemptIn = (list, studentId, testType, quarterStr) =>
  (list || []).reduce((latest, a) => (
    a.studentId === studentId && a.testType === testType && a.quarter === quarterStr && isNewerAttempt(a, latest)
      ? a
      : latest
  ), undefined);

export const isNaAttempt = (a) => !!a && (a.correctCount === -1 || a.correctCount === 'N/A');
